import { motion } from 'framer-motion'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { CategoryTile } from './CategoryTile.styles'

export const Minisearch = styled(motion.div)`
  position: absolute;
  padding: 2rem 4.5rem;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  left: 0;
  right: 0;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.secondary}
    ${({ theme }) => theme.colors.background};

  & p {
    font-size: 1.4rem;
    font-weight: 400;
  }

  & h2 {
    font-family: Jomolhari;
    font-weight: 400;
    font-style: normal;
    font-size: 2rem;
    line-height: 125%;
    letter-spacing: -1px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export const MinisearchContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #313332;

  input {
    margin-left: 1.6rem;
    width: 100%;
    font-family: Jomolhari;
    font-weight: 400;
    font-style: normal;
    font-size: 2.4rem;
    line-height: 125%;
    letter-spacing: -1px;

    border: none;
    outline: none;

    &::placeholder {
      color: #c2c3c3;
      font-family: Jomolhari;
      font-weight: 400;
      font-style: normal;
      font-size: 2.4rem;
      line-height: 125%;
      letter-spacing: -1px;
    }
  }

  button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &.fixed-width {
      width: 2.4rem;
      height: 2.4rem;
    }
  }

  @media (max-width: 768px) {
    margin: 2rem 1.2rem;
    margin-bottom: 0;

    input {
      font-size: 1.8rem;

      &::placeholder {
        font-size: 1.8rem;
      }
    }
  }
`

export const Results = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 4rem;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    flex-grow: 1;
    gap: 3rem;
    margin: 3rem 0;
  }
`

export const SideResults = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex-shrink: 0;
  gap: 5rem;

  @media (max-width: 768px) {
    min-width: 100%;
    gap: 3rem;
  }
`

export const MainResult = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  flex-grow: 1;

  @media (max-width: 768px) {
    flex-grow: 0;
  }
`

export const HorizontalList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4rem 0.5rem;

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    .apparel-product-card {
      flex-basis: 60vw;
      flex-shrink: 0;
    }

    ${CategoryTile} {
      flex-basis: 60vw;
      flex-shrink: 0;
    }
  }
`

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 0 1.2rem;

    &.main {
      padding-right: 0;
    }
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const VerticalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
  }
`

export const FilterChip = styled.button`
  font-family: Jost;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 125%;
  letter-spacing: 0;
  background: #eeeeee;
  color: #313332;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0 1rem;
  width: fit-content;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ViewAllLink = styled.a`
  font-family: Jost;
  font-weight: 400;
  font-style: normal;
  font-size: 1.4rem;
  line-height: 125%;
  letter-spacing: 0;
  text-decoration: underline;
  text-decoration-style: solid;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: 0;
  background: transparent;
  cursor: pointer;
`

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    width: 80vw;
    flex-shrink: 0;
  }
`

export const CardImage = styled(ResponsiveImage)`
  width: 100%;
  height: auto;
  object-fit: cover;
  aspect-ratio: 16 / 10;
`
export const CardLink = styled.a`
  font-family: Jost;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 125%;
  letter-spacing: 0;
  text-decoration: underline;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const NoResults = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1.5rem;

  @media (max-width: 768px) {
    margin-top: 3rem;
  }
`

export const NoResultsTitle = styled.h2`
  font-family: Jomolhari;
  font-weight: 400;
  font-style: normal;
  font-size: 2.4rem;
  line-height: 125%;
  letter-spacing: -1px;
  color: #b0684f;
`

export const NoResultDescription = styled.p`
  font-family: Jost;
  font-weight: 400;
  font-style: normal;
  font-size: 1.6rem;
  line-height: 125%;
  letter-spacing: 0;
  text-align: center;
`
